import { AfterContentInit, Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { PasswordStrengthService } from '../services/password-strength.service';

@Directive({
  selector: '[appPasswordStrength]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: PasswordStrengthDirective,
      multi: true,
    },
  ],
})
export class PasswordStrengthDirective implements AfterContentInit, Validator {
  private element: HTMLInputElement;

  private strength: HTMLElement | undefined;

  constructor(private el: ElementRef, private renderer: Renderer2, private passwordStrength: PasswordStrengthService) {
    this.element = this.el.nativeElement;
    this.element.classList.add('mat-password-strength-element');
  }

  ngAfterContentInit() {
    this.strength = document.createElement('ul');
    this.strength.classList.add('mat-password-strength');
    this.strength.hidden = true;

    this.passwordStrength.tests.forEach(({ text }) => {
      const indicator = document.createElement('li');
      indicator.innerHTML = text;
      if (!this.element.value) {
        indicator.classList.add('empty');
      }
      this.strength!.appendChild(indicator);
    });

    const parent = this.element.closest('.mat-form-field-wrapper') ?? this.renderer.parentNode(this.element);

    this.renderer.appendChild(parent, this.strength);
  }

  validate(): ValidationErrors | null {
    return this.passwordStrength.validatePassword(this.element.value);
  }

  @HostListener('input')
  public onKeyUp(): void {
    if (!this.strength) {
      return;
    }

    const value = this.element.value;
    const indicators = this.strength.getElementsByTagName(`li`);

    // Hide the stength indicator when there is no value
    this.strength.hidden = value.length === 0;

    this.passwordStrength.tests.forEach((test, key: number) => {
      if (value) {
        indicators[key].classList.remove('empty');
      } else {
        indicators[key].classList.add('empty');
      }

      if (test.validate(value)) {
        indicators[key].classList.add('valid');
      } else {
        indicators[key].classList.remove('valid');
      }
    });
  }
}
